import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DotNetOutlinedSvg from "@ant-design/icons-svg/es/asn/DotNetOutlined";
import AntdIcon from '../components/AntdIcon';
var DotNetOutlined = function DotNetOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DotNetOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DotNetOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DotNetOutlined';
}
export default RefIcon;